import { createFileRoute } from '@tanstack/react-router'
import { SavedPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/enregistres')({
  head: () => noIndexRouteHead('saved', 'fr'),
  component: SavedPage,
})
